import React, { useState } from "react";
import styled from "styled-components";
import { SchemeCardDeck } from "../components/card/scheme_card_deck";
import { UserTable } from "../components/table/user_table";
import { UserData } from "../domain/user/user_data";

const Root = styled.div`
  background: #fff;
  padding: 1rem;
`;

const Header = styled.header`
  display: block;
  font-weight: bold;
  letter-spacing: 0.02rem;
  margin-bottom: 1rem;
`;

const Body = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ClientAdminUsersView = () => {
  const [user, setUser] = useState<UserData | null>(null);

  return (
    <Root>
      <Header>Users</Header>

      <Body>
        <div>
          <div style={{ display: 'inline-block', verticalAlign: 'top'}}>
            <UserTable onUserSelected={(user: UserData) => setUser(user)} />
          </div>
          <div style={{ display: 'inline-block', verticalAlign: 'top'}}>
            <SchemeCardDeck user={user} />
          </div>
        </div>
      </Body>
    </Root>
  );
};
